import React from "react";
import { Cell } from "./Cell";

type CellValue = "X" | "O" | null;

interface GameBoardProps {
  board: CellValue[];
  onCellClick: (index: number) => void;
  winningLine: number[] | null;
  disabled: boolean;
}

export function GameBoard({ board, onCellClick, winningLine, disabled }: GameBoardProps) {
  return (
    <div
      className="fade-up delay-2"
      style={{ opacity: 0 }}
    >
      <div
        className="grid grid-cols-3 rounded-xl overflow-hidden"
        style={{
          background: "var(--color-surface)",
          backdropFilter: "blur(12px)",
          border: "1px solid var(--color-grid-line)",
        }}
        role="grid"
        aria-label="Tic Tac Toe board"
      >
        {board.map((cell, i) => (
          <Cell
            key={i}
            value={cell}
            index={i}
            onClick={() => onCellClick(i)}
            isWinning={winningLine?.includes(i) ?? false}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
}
